<script context="module">
    /** static properties so we can have unique ids for each Button */
    export let _id = 1;
</script>

<script lang="ts">
    import { isLoading } from "../api/common";

    export let ref: HTMLElement | undefined = undefined;
    const generatedId = `vv-button-${_id++}`;
    export let id = '';
    export let buttonClass = '';
    export { buttonClass as class };
    type ButtonType = 'primary' | 'secondary' | 'tertiary' | 'fntertiary' | 'danger' | 'navigation' | 'hyperlink' | 'action-center' | undefined;
    export let type: ButtonType = undefined;
    const buttonTypeClasses = {                
        primary: `border-vv-teal bg-vv-teal text-vv-white ring-vv-teal
            hover:bg-vv-teal-dark active:bg-vv-teal-darkest
            disabled:bg-vv-grey-light disabled:border-vv-grey-light disabled:text-vv-grey-power 
            `,
        secondary: `border-vv-grey-mid-light bg-vv-grey-light text-vv-black ring-vv-grey-mid
            hover:bg-vv-grey-mid-light active:bg-vv-grey-mid
            disabled:bg-vv-white disabled:text-vv-grey-power `,
        tertiary: `border-none ring-vv-grey-mid
            hover:bg-vv-grey-light active:bg-vv-grey-mid
            disabled:bg-vv-white disabled:text-vv-grey-power `,
        fntertiary: `border border-solid border-fn-purple text-fn-purple
            hover:bg-vv-grey-light active:bg-vv-grey-mid
            disabled:bg-vv-white disabled:text-vv-grey-power `,
        danger: `border-vv-red-danger bg-vv-red-danger text-vv-white ring-vv-red-danger
            hover:bg-vv-red-danger-dark active:bg-vv-red-danger-darkest
            disabled:bg-vv-grey-light disabled:border-vv-grey-light disabled:text-vv-grey-power`,
        navigation: `border text-black
            hover:bg-vv-grey-light active:bg-vv-grey-mid
            disabled:bg-vv-white disabled:text-vv-grey-power 
            border-solid border-[var(--vv-action-center-button-color)]`,
        hyperlink: `underline text-[#1b75d0] hover:text-[#155ca2] border-none`,
        "action-center": `border-none
            opacity-[0.9] hover:opacity-[1] active:opacity-[1]
            bg-[var(--vv-action-center-button-color,var(--vv-grey-mid))]
            !text-[var(--vv-action-center-button-text,var(--vv-black))]
            ring-[var(--vv-action-center-button-color,var(--vv-grey-mid))]
            disabled:opacity-[0.4]
            `,
    };
    export let disabled = false;
    export let tag: keyof HTMLElementTagNameMap = 'button';
</script>

<svelte:element id={id || generatedId} this={tag} class="rounded !px-2 !py-1 text-center border border-solid border-gray-200
    flex-inline items-center min-h-[45px]
    disabled:cursor-not-allowed
    outline-none focus:outline-none focus-visible:ring focus-visible:ring-2 focus-visible:ring-offset-2
    transition-opacity
    {buttonTypeClasses[type || 'primary']}
    {buttonClass}
    "
    tabindex="0"
    role="button"
    disabled={disabled || $isLoading}
    aria-disabled={disabled || $isLoading}
    on:click
    on:mouseover
    on:mouseenter
    on:mouseleave
    on:mousedown
    on:focus
    on:blur
    {...$$restProps}
    bind:this={ref}>
    <slot></slot>
</svelte:element>
